import { ApiService } from '../../core/services/api/api.service.js';
import { ExperimentService } from './experiment.service.js';
import { DebugService } from './debug.service.js';
import { REFI_ESIGN_CONST } from '../../../constants/app.constants.js';
import { AppService } from '../../app.service.js';

export class _FeatureToggleService {
  constructor() {
    this.debug = new DebugService('FeatureToggleService');
    this.featureToggleComplete = false;
    this._featureToggles = [];
  }

  setFeatureToggles(featureToggles) {
    this._featureToggles = featureToggles;
  }

  async getFeatureToggleStatus(featureKey) {
    const url = REFI_ESIGN_CONST.GET_FEATURE_TOGGLE_URL(featureKey);
    let featureStatus = [this._featureToggles.find(feature => feature.featureKey === featureKey) || false];
    try {
      if (!featureStatus[0]) {
        featureStatus = await ApiService.get(url);
      }
      this.updateStratumExperiments(featureStatus);
      return featureStatus[0].isEnabled;
    } catch (error) {
      this.debug.log('error getting feature toggle status', error);
    }
    return featureStatus[0];
  }

  async getMultipleFeatureToggleStatus(featureKeys) {
    let url = REFI_ESIGN_CONST.GET_FEATURE_TOGGLE_URL('~');
    url = `${url}?featureKeys=${featureKeys}`;
    const toggleArray = this._featureToggles.map(toggles => toggles.featureKey);

    try {
      // loop through the feature toggle object list. if all the feature keys are found in the list, set the list to featureList. If not, make the api call
      const featureList = featureKeys.split(',').every(feature => toggleArray.includes(feature)) ? this._featureToggles : await ApiService.get(url);
      this.updateStratumExperiments(featureList);
      return featureList;
    } catch (error) {
      this.debug.log('error getting feature toggle status', error);
    }
    return null;
  }

  updateStratumExperiments(arrayOfFeatureObjects) {
    const newlyAddedFeatures = [];
    const removedFeatures = [];
    arrayOfFeatureObjects.forEach(featureObj => {
      newlyAddedFeatures.push(featureObj.featureKey + (featureObj.isEnabled ? '-test' : '-bau'));
      removedFeatures.push(featureObj.featureKey + (featureObj.isEnabled ? '-bau' : '-test'));
    });
    ExperimentService.updateExperiments(newlyAddedFeatures, removedFeatures);
  }

  async updateIsETitleIconicAndToggledOn() {
    if (ExperimentService.experiments?.includes('iconic-test')) {
      ExperimentService.isIconicETitleAndToggleOn = await this.getFeatureToggleStatus(REFI_ESIGN_CONST.FEATURE_TOGGLES.ICONIC_ETITLE_FEATURE_TOGGLE);
      this.featureToggleComplete = true;
    } else if (ExperimentService.experiments?.includes('iconic-etitle-only') || ExperimentService?.experiments?.includes('iconic-etitle-stips-only')) {
      ExperimentService.isIconicETitleAndToggleOn = true;
    } else {
      ExperimentService.isIconicETitleAndToggleOn = false;
    }
    this.featureToggleComplete = true;
  }

  async updateIsCombinedHPOrDelayedHP() {
    if (ExperimentService.experiments?.includes('delayed_hard_pull_variant')) {
      ExperimentService.isDelayedHardpullToggledOn = true;
    } else if (
      (ExperimentService.experiments?.includes(REFI_ESIGN_CONST.CUSTOMER_EXPERIENCES.COMBINED_HP_CONTRACT_V1) || ExperimentService.experiments?.includes(REFI_ESIGN_CONST.CUSTOMER_EXPERIENCES.COMBINED_HP_CONTRACT_V2)) &&
      AppService.state.statFlag === 11
    ) {
      ExperimentService.isCombinedHardpullContractToggledOn = true;
    } else {
      ExperimentService.isDelayedHardpullToggledOn = false;
      ExperimentService.isCombinedHardpullContractToggledOn = false;
    }
    this.featureToggleComplete = true;
  }

  async updateIsIconicAndToggledOn() {
    if (ExperimentService.experiments?.includes('iconic-test')) {
      ExperimentService.isIconicAndToggledOn = true;
    } else if (ExperimentService.experiments?.includes('cxt-flow')) {
      // if cxt-flow is enabled, iconic is default on and cxtflow expands from that
      ExperimentService.isIconicAndToggledOn = false;
      ExperimentService.isCxtFlowAndToggledOn = await this.getFeatureToggleStatus(REFI_ESIGN_CONST.FEATURE_TOGGLES.CXTFLOW_FEATURE_TOGGLE);
      this.featureToggleComplete = true;
    } else {
      ExperimentService.isIconicAndToggledOn = false;
    }
    this.featureToggleComplete = true;
  }
}

export const FeatureToggleService = new _FeatureToggleService();
